import { render, staticRenderFns } from "./shopHalfRing.vue?vue&type=template&id=ca0a0a5e&scoped=true"
import script from "./shopHalfRing.vue?vue&type=script&lang=js"
export * from "./shopHalfRing.vue?vue&type=script&lang=js"
import style0 from "./shopHalfRing.vue?vue&type=style&index=0&id=ca0a0a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0a0a5e",
  null
  
)

export default component.exports